import { render, staticRenderFns } from "./KillDialogComponent.vue?vue&type=template&id=5463d378"
import script from "./KillDialogComponent.vue?vue&type=script&lang=js"
export * from "./KillDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./KillDialogComponent.vue?vue&type=style&index=0&id=5463d378&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports